import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, FormGroupDirective, NgForm, UntypedFormControl, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserModel } from '../../../models/user.model';
import { UserService } from '../../services/userService.service';
import { MessageService } from '../../services/messageService.service';
import { Subscription, Observable } from 'node_modules/rxjs';
import { map, first } from 'rxjs/operators';
import { ReCaptchaV3Service, OnExecuteData } from 'ng-recaptcha';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
    selector: 'app-userdataform',
    templateUrl: './userdataform.component.html',
    styleUrls: ['./userdataform.component.scss'],
    providers: [MessageService],
    standalone: false
})
export class UserdataformComponent implements OnInit, OnDestroy {

  userdataForm = new UntypedFormGroup({
    firstName: new UntypedFormControl('', [Validators.required, Validators.minLength(2)]),
    lastName: new UntypedFormControl('', [Validators.required, Validators.minLength(2)]),
    documentNr: new UntypedFormControl('', [Validators.required, Validators.minLength(5)]),
    regulationAccept: new UntypedFormControl(false, Validators.requiredTrue),
    dataProcessAccept: new UntypedFormControl(false, Validators.requiredTrue)
  });

  matcher = new MyErrorStateMatcher();
  message: string;
  loading = false;
  subscription: Subscription;
  state$: Observable<object>;
  private allExecutionsSubscription: Subscription;
  private singleExecutionSubscription: Subscription;
  public recentToken: string = '';
  public errors = [];
  public readonly executionLog: OnExecuteData[] = [];


  constructor(
    private router: Router,
    private userService: UserService,
    private messageService: MessageService,
    public activatedRoute: ActivatedRoute,
    private recaptchaV3Service: ReCaptchaV3Service
    ) {

    }
  ngOnDestroy(): void {
    if (this.allExecutionsSubscription) {
      this.allExecutionsSubscription.unsubscribe();
    }
    if (this.singleExecutionSubscription) {
      this.singleExecutionSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    sessionStorage.removeItem('token');
    this.allExecutionsSubscription = this.recaptchaV3Service.onExecute
      .subscribe((data) => this.executionLog.push(data));
  }
  onSubmit() {
    if (this.singleExecutionSubscription) {
      this.singleExecutionSubscription.unsubscribe();
    }
    this.singleExecutionSubscription = this.recaptchaV3Service.execute('onsubmit')
      .subscribe((token) => {
        this.recentToken = token;

        if (this.userdataForm.invalid) {
          return;
        }
        const userDataModel: UserModel = this.userdataForm.value;
        userDataModel.trainingTypeId = +sessionStorage.getItem('selectedExam');

        this.userService.sendData(userDataModel).subscribe((res) => {
          sessionStorage.setItem('token', res.token);
          this.router.navigate(['/exam']);
        });
      },
      (error) => {
        this.errors = [ 'Error trying to verify request (reCaptcha v3)' ];
        console.log(this.errors);
      });
  }

  // public executeImportantAction(): void {
  //   this.recaptchaV3Service.execute('importantAction')
  //     .subscribe((token) => this.handleToken(token));
  // }
  // handleToken(token){
  //   console.log(token);
  // }
}
